import { useQuery } from '@tanstack/react-query';

import { createMenuManagementAxiosInstance } from 'createAxiosInstance';
import { logException } from 'helpers/loggers';

import type { BuildStatusResponse } from 'containers/MenuUpload/types';

type UseGetMenuBuildStatusParams = {
  companyId: number | null;
  merchantId: number | null;
  jobId: string | null;
};

export const useGetMenuBuildStatus = ({
  companyId,
  merchantId,
  jobId,
}: UseGetMenuBuildStatusParams) => {
  const query = useQuery<BuildStatusResponse | null>({
    queryKey: ['menuBuildStatus', companyId, merchantId, jobId],
    queryFn: async () => {
      try {
        const axios = await createMenuManagementAxiosInstance();
        const response = await axios.get(
          `/company/${companyId}/merchant/${merchantId}/menu/build/status/${jobId}`,
        );
        return response.data ?? null;
      } catch (error) {
        logException({
          message: 'Failed to fetch menu build status',
          error,
          context: {},
          tags: {},
        });
        return null;
      }
    },
    enabled: Boolean(companyId && merchantId && jobId),
    refetchOnMount: 'always',
  });

  return {
    buildStatusData: query.data ?? null,
    isLoading: query.isLoading,
    refetchBuildStatus: query.refetch,
  };
};
